import {saveData, getData} from "../db/db_helper"

//load from DB
export const getOnlineWorkspaceUser = async () =>{
    return await getData("workspace_user") || []
}

export const getAllWorkspaceUser = async () =>{
    const online = await getOnlineWorkspaceUser()
    return online
}

export const getByCode = async(code)=>{
    const online = await getAllWorkspaceUser()
    return online.find(u => u.numberCode === code) || null
}

export const saveWorkspaceUser = async (obj) =>{
    saveData("workspace_user", obj)
}